import React from "react";
import NoteInput from "./NoteInput";
import NoteListActive from "./NoteListActive";
import NoteListArchive from "./NoteListArchive";

class NoteBody extends React.Component {
  constructor(props) {
    super(props);

    this.onDeleteValue = this.onDeleteValue.bind(this);
    this.onArchiveValue = this.onArchiveValue.bind(this);
    this.onAddNoteValue = this.onAddNoteValue.bind(this);
  }

  onDeleteValue(id) {
    this.props.deleteNote(id);
  }

  onArchiveValue(id) {
    this.props.archiveNote(id);
  }

  onAddNoteValue({ title, body }) {
    this.props.createNote({ title, body });
  }

  render() {
    return (
      <div className="note-app__body">
        <NoteInput addNote={this.onAddNoteValue} />
        <h2>Catatan Aktif</h2>
        <NoteListActive
          notes={this.props.notes.filter((note) => note.archived === false)}
          onDelete={this.onDeleteValue}
          onArchive={this.onArchiveValue}
        />
        <h2>Arsip</h2>
        <NoteListArchive
          notes={this.props.notes.filter((note) => note.archived === true)}
          onDelete={this.onDeleteValue}
          onArchive={this.onArchiveValue}
        />
      </div>
    );
  }
}

export default NoteBody;
